import React from "react";
import "../../App.css";
import HeroSection from "../HeroSection";
import Cards from "../Cards";

function Home(props){
    return(
        <>
        <HeroSection/>
        <Cards/>
        </>
    )
}
export default Home;